
    import '/home/ec2-user/Youlify-Design/components/spin/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["spin-demo-basic","spin-demo-size","spin-demo-nested","spin-demo-tip","spin-demo-delayanddebounce","spin-demo-custom-indicator","spin-demo-percent","spin-demo-fullscreen"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/spin/index.en-US.md?type=demo')
};